import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  trend, 
  description,
  onClick 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div 
      className={`
        bg-card rounded-lg border border-border p-18 md:p-24
        transition-smooth hover:shadow-elevation-2
        ${onClick ? 'cursor-pointer' : ''}
      `}
      onClick={onClick}
      role={onClick ? 'button' : 'article'}
      tabIndex={onClick ? 0 : undefined}
    >
      <div className="flex items-start justify-between mb-12 md:mb-18">
        <div className="flex-1">
          <p className="font-caption text-[12px] md:text-[13px] text-muted-foreground uppercase tracking-wide mb-6">
            {title}
          </p>
          <h3 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground">
            {value}
          </h3>
        </div>
        <div className="w-[40px] h-[40px] md:w-[48px] md:h-[48px] rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon 
            name={icon} 
            size={20} 
            color="var(--color-primary)" 
            strokeWidth={2} 
          />
        </div>
      </div>

      {description && (
        <p className="font-body text-[13px] md:text-[14px] text-muted-foreground mb-12">
          {description}
        </p>
      )}

      <div className="flex items-center gap-12">
        <div className={`flex items-center gap-6 ${getChangeColor()}`}>
          <Icon 
            name={getChangeIcon()} 
            size={16} 
            color="currentColor" 
            strokeWidth={2} 
          />
          <span className="font-body font-semibold text-[13px] md:text-[14px]">
            {change}
          </span>
        </div>
        {trend && (
          <span className="font-caption text-[12px] md:text-[13px] text-muted-foreground">
            {trend}
          </span>
        )}
      </div>
    </div>
  );
};

export default MetricCard;